import { render, staticRenderFns } from "./serviceListHome.vue?vue&type=template&id=0c69ea33&scoped=true"
import script from "./serviceListHome.vue?vue&type=script&lang=js"
export * from "./serviceListHome.vue?vue&type=script&lang=js"
import style0 from "./serviceListHome.vue?vue&type=style&index=0&id=0c69ea33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c69ea33",
  null
  
)

export default component.exports